export default __webpack_public_path__ + "static/media/shopping-cart.950ba699.png";